import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Option } from '../../models/option.model';

@Component({
  selector: 'app-sd-selector',
  templateUrl: './sd-selector.component.html',
  styleUrls: ['./sd-selector.component.scss'],
})
export class SdSelectorComponent {
  constructor(private readonly changeDetector: ChangeDetectorRef) {}
  @Input() options: Option[];
  @Input() placeholder: string;
  @Input() controller: UntypedFormControl;
  @Input() error: string;
  @Input() displaySvg = false;
  @Input() withOutThis: boolean;
  @Input() roundedAvatar = true;
  @Input() readOnly = false;
  @Input() innerHtmlElements = false;
  @Input() tooltip: string;
  @Output() selection = new EventEmitter<string>();
}
